import script from "./DesktopReactionsControlsItem.vue?vue&type=script&setup=true&lang=ts"
export * from "./DesktopReactionsControlsItem.vue?vue&type=script&setup=true&lang=ts"

import "./DesktopReactionsControlsItem.vue?vue&type=style&index=0&id=9d35716c&lang=scss"

const __exports__ = script;

export default __exports__